import { render, staticRenderFns } from "./DataInstances.vue?vue&type=template&id=71592a64&"
import script from "./DataInstances.vue?vue&type=script&lang=ts&"
export * from "./DataInstances.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports